export default __webpack_public_path__ + "static/media/WD-678X 2D wired handheld barcode scanner.c0823dc5.jpg";